module.exports = __webpack_public_path__ + "img/service_mobile_1_mob_2x.422bda89.jpg";